interface AccessAction {
  [key: string]: {
    PATH: string;
    KEY: number;
    NAME: string;
    METHOD: string;
  };
}
export const ACCESSACTION: AccessAction = {
  FINDALLPATIENT: {
    PATH: "patient/findAll",
    KEY: 1,
    NAME: "Find All Patient",
    METHOD: "GET",
  },
  DELETEPATIENT: {
    PATH: "patient/delete",
    KEY: 2,
    NAME: "Delete Patient",
    METHOD: "DELETE",
  },
  EDITINVOICE: {
    PATH: "payment/editPayment",
    KEY: 3,
    NAME: "Edit Payment",
    METHOD: "PATCH",
  },
};
